const getCode = (state) => state.registration.code;

const getRegistering = (state) => state.registration.registering;

export default {
    getCode,
    getRegistering
};
